/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Typography } from "@mui/material";

const FormLabel = (props) => {
    
    const { text } = props;
    
    return (
        <Typography variant='overline' color={"text.secondary"}>
            {text}:
        </Typography>
    );
};

FormLabel.displayName = "FormLabel";
export { FormLabel }; 
